module.exports = __webpack_public_path__ + "static/media/reward-four.9201bee1.svg";